import { days } from '~/lib/datetime/mod.js';

const MIN_FONT_SIZE_PX = 18;

const MAX_FONT_SIZE_PX = 24;

export const getClampedFontSizePx = fontSizePx =>
	Math.min(MAX_FONT_SIZE_PX, Math.max(MIN_FONT_SIZE_PX, fontSizePx));

Object.defineProperties(getClampedFontSizePx, {
	Max: { value: MAX_FONT_SIZE_PX },
	Min: { value: MIN_FONT_SIZE_PX },
});

/**
 * How many days after the menu was last opened that the menu button's logo pulse stays hidden.
 */
export const LOGO_PULSE_SUPPRESS_DAYS = 90;

/**
 * @param {Date} date
 * @returns {number} Timestamp (ms) of local midnight on `date`'s calendar date.
 */
const toLocalMidnight = date =>
	new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

/**
 * @param {number | null | undefined} menuLastOpenedAt Timestamp (ms) the menu was last opened, if
 *   ever.
 * @param {Date} [now]
 * @returns {boolean} Whether the pulse should be shown: the menu has never been opened, or was last
 *   opened over {@link LOGO_PULSE_SUPPRESS_DAYS} calendar days ago. Only the (local) dates are
 *   compared, not the times of day.
 */
export const isLogoPulseDue = (menuLastOpenedAt, now = new Date()) => {
	if (!menuLastOpenedAt) {
		return true;
	}

	// Rounded since DST shifts can make a calendar day 23 or 25 hours long.
	const daysSinceOpened = Math.round(
		(toLocalMidnight(now) - toLocalMidnight(new Date(menuLastOpenedAt))) / days(1)
	);

	return daysSinceOpened > LOGO_PULSE_SUPPRESS_DAYS;
};
